<template>
    <div class="page-container">
        <SidebarComponent />
        <div class="page-content">
            <ItinerariesComponent baseUrl="https://ssot.laculturapremia.it/api" :languageJson="languageJson"
                :token="token" :router="router" :sortOnly="false" />
        </div>
    </div>
</template>

<script>
import SidebarComponent from '@/components/Sidebar.vue';
import ItinerariesComponent from "@laculturapremia/itineraries/dist/itineraries.common";
import { useRouter } from 'vue-router';
import { onBeforeMount, ref } from 'vue';

export default {
    name: 'HomePage',
    components: {
        SidebarComponent,
        ItinerariesComponent
    },
    setup() {
        const token = ref('');
        const getError = ref(null);
        const router = useRouter();

        const languageJson = [
            {
                lang_code: "fr",
                name: "Francese",
                fallback: "en",
                is_sign_language: false,
                display_on_app: true,
                name_original_lang: "Française",
                tours_only: false,
                required: false,
                is_rtl: false
            },
            {
                lang_code: "it",
                name: "Italiano",
                fallback: null,
                is_sign_language: false,
                display_on_app: true,
                name_original_lang: "",
                tours_only: false,
                required: true,
                is_rtl: false
            },
            {
                lang_code: "es",
                name: "Spagnolo",
                fallback: "en",
                is_sign_language: false,
                display_on_app: true,
                name_original_lang: "Español",
                tours_only: false,
                required: true,
                is_rtl: false
            },
            {
                lang_code: "en",
                name: "Inglese",
                fallback: null,
                is_sign_language: false,
                display_on_app: true,
                name_original_lang: "",
                tours_only: false,
                required: true,
                is_rtl: false
            },
            {
                lang_code: "it:lis",
                name: "Italiano (LIS)",
                fallback: "it",
                is_sign_language: true,
                display_on_app: true,
                name_original_lang: "",
                tours_only: true,
                required: false,
                is_rtl: false
            },
            {
                lang_code: "ar",
                name: "Arabo",
                fallback: "en",
                is_sign_language: false,
                display_on_app: true,
                name_original_lang: "العربية",
                tours_only: false,
                required: false,
                is_rtl: true
            }
        ];

        const getToken = () => {
            const data = localStorage.getItem('mi_cms-tokens');
            if (data === null || data === undefined || data === '')
                getError.value = 'There is no token'
            else {
                token.value = JSON.parse(data).access;
                getError.value = null;
            }
        }

        onBeforeMount(() => {
            getToken();
        })


        return {
            token,
            router,
            languageJson,
        }
    }
}
</script>

<style>
.page-container {
    display: flex;
}

.page-content {
    padding: 16px;
    width: 75%;
}
</style>